"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getTranslationsProps = require("./getTranslationsProps");
Object.keys(_getTranslationsProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTranslationsProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTranslationsProps[key];
    }
  });
});
var _isInShoppingPage = require("./isInShoppingPage");
Object.keys(_isInShoppingPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isInShoppingPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isInShoppingPage[key];
    }
  });
});
var _mapShoppingBagItem = require("./mapShoppingBagItem");
Object.keys(_mapShoppingBagItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapShoppingBagItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapShoppingBagItem[key];
    }
  });
});
var _removeBasketItem = require("./removeBasketItem");
Object.keys(_removeBasketItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _removeBasketItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _removeBasketItem[key];
    }
  });
});
var _showErrorNotification = require("./showErrorNotification");
Object.keys(_showErrorNotification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _showErrorNotification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _showErrorNotification[key];
    }
  });
});
var _updateBasketItem = require("./updateBasketItem");
Object.keys(_updateBasketItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateBasketItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateBasketItem[key];
    }
  });
});
var _triggerShareItemClickEvent = require("./triggerShareItemClickEvent");
Object.keys(_triggerShareItemClickEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _triggerShareItemClickEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _triggerShareItemClickEvent[key];
    }
  });
});
